/* eslint-disable react/jsx-props-no-spreading */
import { Checkbox as InMarKitCheckbox, CheckboxProps as InMarketCheckboxProps, FormControlLabel } from '@mui/material';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface CheckboxProps extends InMarketCheckboxProps {
  label: string;
  normalizeOutput?: Function;
  normalizeInput?: Function;
}

function Checkbox({
  name,
  label,
  disabled = false,
  normalizeOutput = (output) => output,
  normalizeInput = (input) => input,
  ...rest
}: CheckboxProps) {
  const { control } = useFormContext();
  const { field } = useController({ control, name });
  return (
    <FormControlLabel
      label={label}
      disabled={disabled}
      control={
        <InMarKitCheckbox
          name={field.name}
          checked={normalizeInput(field.value)}
          onChange={(e) => field.onChange(normalizeOutput(e))}
          onBlur={field.onBlur}
          inputRef={field.ref}
          {...rest}
        />
      }
    />
  );
}

export default Checkbox;
